import Document from '../components/Document';

export default function PolicyPage() {
    const policyUrl = 'https://drive.google.com/file/d/1_TFBn42Bbt62vZ-_wWYehsfSyfwOi4LA/preview';
    return (
        <Document url={policyUrl} title='Policy' />
    )
}